import React from 'react';

import { VasList } from '../../../../components/VasList';
import { useAuctionContext } from '../../../../context/AuctionContext';
import { useOfferContext } from '../../../../context';
import { AuctionApplyNewBetHintContainer } from '../AuctionApplyNewBetHintContainer';

export function VASListContainer() {
  const { isAgent, vasList } = useOfferContext();
  const { currentBet, liquidityPoints } = useAuctionContext();

  if (!isAgent || vasList.length === 0) {
    return null;
  }

  return (
    <VasList
      items={vasList}
      bet={currentBet}
      liquidityPoints={liquidityPoints}
      nextBetTip={<AuctionApplyNewBetHintContainer />}
    />
  );
}
